export const escrowEn = {};

export const escrowFr = {};
